export const generalTypes = {
  GET_INIT_DATA: 'general/GET_INIT_DATA',
  INIT_DATA_RES: 'general/INIT_DATA_RESPONSE',
  DISPLAY_ALERT: 'general/DISPLAY_ALERT',
  ADMIN_INIT: 'general/GET_ADMIN_INIT_DATA',
  ADMIN_INIT_RES: 'general/ADMIN_INIT_RESPONSE',
  SAVE_SCHEDULES: 'general/SAVE_SCHEDULES'
}

export const getInitData = () => (
  {
    type: generalTypes.GET_INIT_DATA
  }
)

export const displayAlert = (text) => (
  {
    type: generalTypes.DISPLAY_ALERT,
    text
  }
)

export const getAdminInitData = (city) => (
  {
    type: generalTypes.ADMIN_INIT,
    city
  }
)



// WEBPACK FOOTER //
// ./src/actions/general.js